"use strict";
export function syncUntrackedInput(valueLink) {
  return (event) => {
    var _a;
    const domValue = event.currentTarget.value;
    if (domValue !== ((_a = valueLink.value) != null ? _a : "")) {
      valueLink.requestChange(domValue);
    }
  };
}
